<div class="rounded rounded-3 bg_gray payment-fixed payment-details-block second-step--outerwrap" #scrollMe #screenshotRoot tabindex="-1" [class.ar-new-flow]="split_request_data && split_request_data[0]?.ar_flow_immediate">
  <div class="panel-outer--mainwrapper"  #screenManager [ngClass]="{'borderBottom': stepHeader}">
    <div class="sidebar_plan_details" [ngClass]="mainService.current_step > 1 ? 'showing-plan' :''"
      [class.cross--five]="mainService.current_step == 5">
      <app-steps (triggerChangeScreen)="changeScreen()"></app-steps>
    </div>
    <div class="screen_manager">
      <div class="progress-main--wrapper row" [ngClass]="mainService.current_step == 3 ? 'stepthree' : ''">
        <div class="make_sticky progress-main--wrapper__left col-md-3 d-none d-md-block"
          [ngClass]="mainService.current_step == 2 || mainService.current_step == 3 || mainService.current_step == 4 || mainService.current_step == 5 ? 'bottom-stick' : ''">
          <span class="flex-grow-1 text-center" style="max-width: -webkit-fill-available;"
            *ngIf="mainService.current_step == 2 || mainService.current_step == 3 || mainService.current_step == 4 || mainService.current_step == 5">
            <ul class="list-unstyled form-wizard-steps clearfix mb-0 mx-auto">
              <li class="activeted"
                [ngClass]="mainService.current_step == 1 ? 'active' :mainService.current_step == 2||3||4||5? 'completeData':''"
                (click)="backToPayment()" [class.disabled]="mainService.current_step == 5">
                Payment Plan</li>
              <li
                [ngClass]=" mainService.current_step == 2 ? 'active' :mainService.current_step == 3||4||5? 'completeData':''"
                class="activeted" (click)="mainService.current_step = 2"
                [class.disabled]="mainService.current_step == 5">Personal Details</li>
              <li
                [ngClass]=" mainService.current_step == 3 ? 'active' :mainService.current_step == 4 || mainService.current_step == 5? 'completeData':''"
                class="activeted" (click)="mainService.current_step = 3"
                [class.disabled]="mainService.current_step == 5" *ngIf="split_request_data && !split_request_data[0]?.ar_flow_immediate">Recurring Details</li>
              <li class="activeted"
                [ngClass]=" mainService.current_step == 4 ? 'active' : mainService.current_step == 5?'completeData':''"
                (click)="mainService.current_step = 4" [class.disabled]="mainService.current_step == 5">
                Make Payment</li>
              <li class="activeted" [ngClass]=" mainService.current_step == 5 ? 'active' : ''">Additional Information
              </li>
            </ul>
          </span>
          <!-- <span class="flex-grow-1 text-end" [ngClass]="mainService.current_step > 1 ? 'steps-outside' : ''">
            <app-steps closeOnly="true" api="true"></app-steps>
          </span> -->
          <ng-container>
            <div class="button_back_inside">
              <span [ngClass]="mainService.current_step == 5 ? 'fivesteps' : ''">
                <span class="left-back-btn d-flex align-items-center" (click)="changeScreen()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M14 17L9.5 12.5L14 8" stroke="#646C70" stroke-width="1.8" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  Previous Step
                </span>
              </span>
              <!-- <span>
                <span class="fs-16 color-gray" *ngIf="mainService.current_step == 3">
            Payment Plan
          </span>
                <span class="fs-16 color-gray payment-title" *ngIf="mainService.current_step == 2">
                  Personal Details
                </span>
                <span class="fs-16 color-gray payment-title" *ngIf="mainService.current_step == 3">
                  Recurring Details
                </span>
                <span class="fs-16 color-gray payment-title" *ngIf="mainService.current_step == 4">
                  Make Payment
                </span>
              </span> -->
              <!-- <span [ngClass]="mainService.current_step == 2 ? 'steps-outside' : ''">
                <app-steps closeOnly="true" api="true"></app-steps>
              </span> -->
            </div>
          </ng-container>

        </div>
        <!-- Back Button Insied second -->
        <!-- <ng-container>
          <div
            class="w-100 px-lg-5 px-4 py-lg-3 py-0 justify-content-between align-items-center button_back_inside position-absolute">
            <span [ngClass]="mainService.current_step == 5 ? 'fivesteps' : ''">
              <span
                class="p-2 d-flex align-items-center jusitfy-content-center bg-white border rounded-circle left-back-btn"
                role="button_close" (click)="changeScreen()">
                <img src="assets/svg/back_arrow.svg" alt="" />
              </span>
            </span>
            <span>
              <span class="fs-16 color-gray" *ngIf="mainService.current_step == 3">
          Payment Plan
        </span>
              <span class="fs-16 color-gray payment-title" *ngIf="mainService.current_step == 2">
                Personal Details
              </span>
              <span class="fs-16 color-gray payment-title" *ngIf="mainService.current_step == 3">
                Recurring Details
              </span>
              <span class="fs-16 color-gray payment-title" *ngIf="mainService.current_step == 4">
                Make Payment
              </span>
            </span>
            <span [ngClass]="mainService.current_step == 2 ? 'steps-outside' : ''">
              <app-steps closeOnly="true" api="true"></app-steps>
            </span>
          </div>
        </ng-container> -->

        <!-- <span class="mb-2 p-2 button_back_round d-flex align-items-center jusitfy-content-center rounded-circle"
          role="button_close"
          *ngIf="canGoBack() && (mainService.current_step == 2 || mainService.current_step == 3 || mainService.current_step == 4)"
          (click)="changeScreen()">
          <img src="assets/svg/back_arrow.svg" alt="" />
        </span> -->
        <div #scrollMe class="progress-main--wrapper__right col-md-9"
          [ngClass]="mainService.current_step == 5 ? '-step-five--enable' : '' ">
          <div class="container-fluid reduce_top_padding bg-white h-100"
            [ngClass]="{'deff': (contract_type == 6 && mainService.current_step == 5)}">
            <!-- *ngIf="mainService.current_step == 2" -->
            <ng-container *ngIf="mainService.current_step == 2 || (mainService.current_step == 3 && split_request_data[0]?.ar_flow_immediate)">
              <div class="input_containers_head fw-700 fs-16 mb-0 color-gray px-4 dsk-hide">
                <div class="button_back_inside">
                  <span [ngClass]="mainService.current_step == 5 ? 'fivesteps' : ''">
                    <span class="left-back-btn" (click)="changeScreen()">
                      <!-- <img src="assets/png/arrow-left.png" alt=""> -->
                      <!-- Previous Step -->
                    </span>
                  </span>
                </div>
                <span class="data_personal">Personal details</span>
              </div>
              <div class="form-inside px-xl-4 px-2 plan_down">
                <form class="row" (submit)="addAddressFn(patient_address)" autocomplete="off">
                  <!-- First Name -->
                  <ng-container [formGroup]="patient_address">
                    <div class="input_container col-md-6">
                      <div class="flex-grow-1">
                        <!-- inputContainer -->
                        <div class="w-100 custom-form-v5 flex-grow-1">
                          <input type="text" class="input_field px-3 pt-3" formControlName="patient_first_name"
                            name="patient_first_name" required maxlength="100" id="patient_first_name" [ngClass]="{
                              'black-border': patient_address.value.patient_first_name,
                              'normal-border': !patient_address.value.patient_first_name,
                              'has-error': patient_address.controls.patient_first_name.touched && patient_address.controls.patient_first_name.invalid
                          }" autocomplete="off" />
                          <span
                            *ngIf="(!patient_address.value.patient_first_name || patient_address.value.patient_first_name.trim().length == 0) && showvalidation"
                            class="text-danger name-invalid">Please enter First Name</span>
                          <label for="text" class="label-name">
                            <span class="content-name_1 f-c-p-3">
                              First Name
                            </span>
                          </label>
                        </div>
                        <!-- <p class="mat-error"
                    >
                    Please enter a valid service name.</p> -->
                      </div>
                    </div>
                    <!-- last Name -->
                    <div class="mt-4 mt-md-0 input_container col-md-6">
                      <div class="flex-grow-1">
                        <div class="custom-form-v5 flex-grow-1">
                          <input type="text" class="input_field px-3 pt-3" formControlName="patient_last_name"
                            name="patient_last_name" required maxlength="100" [ngClass]="{
                              'black-border': patient_address.value.patient_last_name,
                              'normal-border': !patient_address.value.patient_last_name,
                              'has-error': patient_address.controls.patient_last_name.touched && patient_address.controls.patient_last_name.invalid
                          }" autocomplete="off" />
                          <span
                            *ngIf="(!patient_address.value.patient_last_name || patient_address.value.patient_last_name.trim().length == 0) && showvalidation"
                            class="text-danger name-invalid">Please enter Last Name</span>
                          <label for="text" class="label-name">
                            <span class="content-name_1 f-c-p-3">
                              Last Name
                            </span>
                          </label>
                        </div>
                        <!-- <p class="mat-error"
                    >
                    Please enter a valid service name.</p> -->
                      </div>
                    </div>
                    <!-- Email Address -->
                    <div class="input_container col-md-12 mt-4">
                      <div class="flex-grow-1">
                        <div class="custom-form-v5 flex-grow-1">
                          <input type="text" class="input_field px-3 pt-3" formControlName="patient_email"
                            name="patient_email" required maxlength="100" autocomplete="off" />
                          <span
                            *ngIf="(!patient_address.controls.patient_email.disabled && !patient_address.value.patient_email || patient_address.value.patient_email && this.patient_address.value.patient_email.trim().length == 0) && showvalidation"
                            class="text-danger name-invalid">Please enter Email</span>

                          <label for="text" class="label-name">
                            <span class="content-name_1 f-c-p-3">
                              Email Address
                            </span>
                          </label>
                        </div>

                      </div>
                    </div>

                    <!-- Customer Predfered Language -->
                    <div class="input_container col-md-12 mt-4">
                      <div class="flex-grow-1">
                        <div class="custom-form-v5 flex-grow-1">
                          <select class="input_field col-12 language-chnge" formControlName="language_preffered"
                            [ngClass]="{
                            'black-border': patient_address.value.language_preffered,
                            'normal-border': !patient_address.value.language_preffered
                        }" id="img_logo_emp">
                            <option *ngFor="let lang of language_data; let i=index" [value]="lang.lan_code">
                              {{lang.lan_name}}</option>
                          </select>
                          <label for="text" class="label-name">
                            <span class="content-name f-c-p-3"
                              style="font-size: 12px; bottom: 7px; top: 8px;left: 16px;">
                              Select Preferred <span class="hide">Communication</span> Language (Email/SMS)
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- Phone Number  -->


                    <!-- <div class="input_container col-md-12">
                    <div
                      [ngClass]="[profileForm.controls.phone && profileForm.controls.phone.touched && profileForm.controls.phone.invalid  ? 'inputContainer custom-form' : 'custom-form']">
                      <mat-select
                        [ngStyle]="{'background-image': 'url(assets/img/svg/country_flag/' + ((profileForm.controls.doctor_mobile_country_code.value + '') | lowercase) + '_flag.svg)'}"
                        id="img_logo_emp" class="flag_dropdown input_field font-weight-bold m-h-56 h-100 w-100"
                        formControlName="doctor_mobile_country_code">
                        <mat-option *ngFor="let option of countryList;let i=index" [value]="option.country_code">
                          <i class="fi fi-{{option.country_code | lowercase}}"></i>
                          <span class="ps-2" style="color: #8c8989;">{{option.mobile_code}}</span>
                        </mat-option>
                      </mat-select>
                      <input class="input_field pt-3 mobile-field-patient" [ngStyle]="{'padding-left':'1rem'}" name="phone"
                        [formControl]="profileForm.controls['phone']" [mask]="phone_mask" required />
                      <label for="text" class="label-name">
                        <span style="left: 106px;" class="content-name f-c-p-3">
                          {{ label.PHONE }}
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="(profileForm.controls.phone.invalid && profileForm.controls.phone.touched) || (profileForm.controls.phone.invalid && profileForm.controls.phone.dirty)">
                      Please enter your Phone Number
                    </p>
                  </div> -->


                    <div class="input_container col-md-12 mt-4" [class.add-label]="(patient_address.controls.patient_mobile.touched  || patient_address.controls.patient_mobile.dirty) && (patient_address.controls.patient_mobile.invalid)">
                      <div class="flex-grow-1">
                        <div class="custom-form-v5 flex-grow-1" [ngClass]="{
                          'black-border': ((patient_address.value.patient_mobile) && (!patient_address.controls.patient_mobile.invalid)),
                          'normal-border': !patient_address.value.patient_mobile,
                          'has-error': (patient_address.controls.patient_mobile.touched  || patient_address.controls.patient_mobile.dirty) && (patient_address.controls.patient_mobile.invalid)
                      }">
                          <mat-select disabled id="img_logo_emp"
                            class="flag_dropdown input_field font-weight-bold m-h-52 h-100 w-100"
                            [ngClass]="'ps-' + (4 - patient_address.controls.patient_mobile_country_code.value.length)"
                            formControlName="patient_mobile_country_code">
                            <mat-select-trigger>
                              <!-- <img style="width: 2.5rem;" src="assets/svg/country_flag/{{flag_code}}_flag.svg" > -->
                              <span> {{patient_address.controls.patient_mobile_country_code.value}} </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let option of mainService.mobile_code_arr;let i=index" [value]="option">
                              <!-- <img style="width: 1.33333333em;" src="assets/svg/country_flag/{{option.country_code | lowercase}}_flag.svg" > -->
                              <span class="ps-2" style="color: #8c8989;">{{option}}</span>
                            </mat-option>
                          </mat-select>
                          <input type="text" class="input_field pe-3 pt-3 mobile-field-patient"
                            [ngStyle]="{'padding-left': '1rem'}" formControlName="patient_mobile" name="patient_mobile"
                            required [maxlength]="phone_length" [minlength]="min_phone_length" autocomplete="off" [mask]="mask" [validation]="false" />
                            @if ((patient_address.controls.patient_mobile.touched  || patient_address.controls.patient_mobile.dirty) && (patient_address.controls.patient_mobile.invalid)) {
                              <span class="text-danger name-invalid">Please enter a valid Phone Number</span>   
                            } @else {
                              <span
                                *ngIf="(!patient_address.value.patient_mobile || patient_address.value.patient_mobile.trim().length == 0) && showvalidation"
                                class="text-danger name-invalid">Please enter Phone Number</span>
                            }
                          <label for="text" class="label-name">
                            <span style="left: 85px" class="content-name_1 f-c-p-3">
                              Phone Number
                            </span>
                          </label>
                        </div>
                        <!-- <p class="mat-error"
                    >
                    Please enter a valid service name.</p> -->
                      </div>
                    </div>

                    <!-- Address -->
                    <div class="input_container col-md-12 mt-4">
                      <div class="flex-grow-1">
                        <div *ngIf="showGoogleApi" class="custom-form-v5 flex-grow-1" [ngClass]="{
                          'google-black': patient_address.value.address,
                          'after-field': !patient_address.value.address,
                          'google-has-error':(!patient_address.value.address || patient_address.value.address.trim().length == 0) && showvalidation
                      }">
                          <app-google-api [label]="'Address'" (setAddress)="getZipselected($event)" [t]="1" [customClass]="['custom-form-v5']"
                            [isRequired]="true" id="zipPostalCode" name="zipPostalCode" [model]="patient_address.controls.address.value"
                            ngDefaultControl [defaultzip]="zipCode" zipcodeNull="arDetail" [addressDetail]="planInfo" [editAddressManually]="editAddressManually">
                          </app-google-api>
                          <div>
                            <span
                              *ngIf="((!patient_address.value.address || patient_address.value.address.trim().length == 0)) && showvalidation"
                              class="text-danger name-invalid-zip">Please enter address</span>
                          </div>
                        </div>
                        <!-- <p class="mat-error"
                    >
                    Please enter a valid service name.</p> -->
                      </div>
                    </div>
                    <div class="input_container col-md-12 mt-4">
                      <div class="flex-grow-1">
                        <div class="custom-form-v5 flex-grow-1">
                          <input type="text" class="input_field px-3 pt-3" formControlName="address_2" name="address_2"
                            maxlength="100" [ngClass]="{'black-border': patient_address.value.address_2}"
                            autocomplete="off" />
                          <label for="text" class="label-name">
                            <span class="content-name_1 f-c-p-3">
                              Address Line 2 (Optional)
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>

                  </ng-container>
                  <!-- other Part -->
                  <ng-container [formGroup]="patient_address">
                    <!-- ZIP -->
                    <div class="input_container col-md-12 mt-4">
                      <div class="flex-grow-1">
                        <div class="custom-form-v5 flex-grow-1">
                          <input type="text" class="input_field px-3 pt-3" formControlName="zip" name="address"
                            required maxlength="8" [ngClass]="{
                              'black-border': patient_address.value.zip,
                              'normal-border': !patient_address.value.zip,
                              'has-error': (!patient_address.controls?.zip.value || 
                              (patient_address.controls?.zip?.value && 
                               (patient_address.controls?.zip?.value?.toString().trim().length === 0))) 
                              && showvalidation
                          }" autocomplete="off" (keypress)="mainService.handleInputSpace($event)" (blur)="customZip = true; editAddressManually = true" />
                          <span
                            *ngIf="(patient_address.controls.zip.touched && (!patient_address.controls?.zip.value || 
                            (patient_address.controls?.zip?.value && 
                             (patient_address.controls?.zip?.value?.toString().trim().length === 0)))) 
                            && showvalidation"
                            class="text-danger name-invalid">Please enter zip/postal Code</span>
                          <label for="text" class="label-name">
                            <span class="content-name_1 f-c-p-3">
                              Zip/Postal Code
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- State -->
                    <div class="input_container col-md-6 mt-4">
                      <div class="flex-grow-1">
                        <div class="custom-form-v5 flex-grow-1">
                          @if(showDropDown) {
                            <select class="input_field language-chnge px-3 pt-3" formControlName="state_code"
                              (change)="stateSelected(patient_address.controls.state_code.value)"
                              name="state_name" required maxlength="100" [ngClass]="{
                                'black-border': patient_address.value.state_code,
                                'normal-border': !patient_address.value.state_code,
                                'has-error': patient_address.controls.state_code.touched && patient_address.controls.state_code.invalid
                            }" autocomplete="off">
                            <option *ngFor="let state of country_states" [value]="state.state_code">{{state.state_name}}</option>
                          </select>
                          } @else {
                            <input type="text" class="input_field px-3 pt-3" formControlName="state_name"
                              name="state_name" required maxlength="100" disabled [ngClass]="{
                                'black-border': patient_address.value.state_name,
                                'normal-border': !patient_address.value.state_name,
                                'has-error': patient_address.controls.state_name.touched && patient_address.controls.state_name.invalid
                            }" autocomplete="off" />
                          }
                          <label for="text" class=""
                            [ngClass]="((!patient_address.controls.state_name.value && !patient_address.controls.state_code.value) && (patient_address.value.zipSelected)) ? '' : 'label-name'">
                            <span class="content-name_1 f-c-p-3" [ngClass]="{'mb-3': patient_address.controls.state_code.value && showDropDown}">
                              State
                            </span>
                          </label>
                        </div>
                        <!-- <p class="mat-error"
                  >
                  Please enter a valid service name.</p> -->
                      </div>
                    </div>
                    <!-- City -->
                    <div class="input_container input_container1 col-md-6 mt-4">
                      <div class="flex-grow-1">
                        <div class="custom-form-v5 flex-grow-1">
                          <input appAlphabetsOnly type="text" class="input_field px-3 pt-3" formControlName="city" name="city" required
                            maxlength="100" [ngClass]="{
                              'black-border': patient_address.value.city,
                              'normal-border': !patient_address.value.city,
                              'has-error': patient_address.controls.city.touched && patient_address.controls.city.invalid
                          }" autocomplete="off" (blur)="customZip = true; editAddressManually = true; getZipselected({});trimControl('patient_address', 'city')"/>
                          <label for="text" class=""
                            [ngClass]="(!patient_address.controls.city.value && (patient_address.value.zipSelected)) ? '' : 'label-name'">
                            <span class="content-name_1 f-c-p-3">
                              City
                            </span>
                          </label>
                        </div>
                        <!-- <p class="mat-error"
                  >
                  Please enter a valid service name.</p> -->
                      </div>
                    </div>
                    <!-- SSN -->
                    <div class="input_container col-md-12 mt-4" *ngIf="showSSNfields">
                      <div class="flex-grow-1">
                        <div class="custom-form-v5 flex-grow-1">
                          <input type="text" class="input_field px-3 pt-3" formControlName="patient_ssn"
                            name="patient_ssn" required minlength="{{mainService.minDocumentIdLength}}"
                            maxlength="{{mainService.maxDocumentIdLength}}" [ngClass]="{
                              'black-border': patient_address.value.patient_ssn,
                              'normal-border': !patient_address.value.patient_ssn,
                              'has-error': patient_address?.controls?.patient_ssn?.errors?.err
                          }" autocomplete="off" (input)="alphabet($event)"
                            [class.ng-valid]="patient_address.value.patient_ssn && patient_address.value.patient_ssn.length" />
                          <span *ngIf="patient_address?.controls?.patient_ssn?.errors?.err"
                            class="text-danger name-invalid">{{'Please enter a valid ' +
                            this.mainService.document_label}}</span>
                          <label for="text" class="label-name">
                            <span class="content-name_1 f-c-p-3"
                              [class.show-error]="patient_address?.controls?.patient_ssn?.errors?.err">
                              <!-- Social Security Number -->
                              {{mainService.document_label}}
                            </span>
                          </label>
                          <div *ngIf="mainService.document_ids_list" class="document_id">
                            <button type="button" class="info_icon_btn">
                              <img src="assets\png\Icons.png" alt="" class="info_icon">
                              <span class="tooltip_box  color-gray-1 show_div document_id_toottip d-none">
                                <p class="p-0 m-0 fw-400 -treatment_text" style="color: #646c70;">
                                  {{mainService.document_ids_list}}
                                </p>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <!-- Continue Button -->
                  <div class="col-12">
                    <button class="mt-4 blue-btn plans-btn fs-16 blue-btn-v2" button-primary-auth type="submit"
                      id="Continue1">Continue</button>
                  </div>
                </form>

              </div>
            </ng-container>

            <!-- *ngIf="mainService.current_step == 3"  && (ar_flow_immediate) this is new flow-->
            <ng-container *ngIf="split_request_data && !split_request_data[0]?.ar_flow_immediate && (mainService.current_step == 3 && planInfo)">
              <div class="input_containers_head fw-700 fs-16 mb-0 color-gray px-4 d-md-none">
                <div class="button_back_inside dsk-hide">
                  <span [ngClass]="mainService.current_step == 5 ? 'fivesteps' : ''">
                    <span class="left-back-btn" (click)="changeScreen()">
                      <!-- <img src="assets/png/arrow-left.png" alt=""> -->
                      <!-- Previous Step -->
                    </span>
                  </span>
                </div>
                <span class="data_personal">
                  Recurring Details
                </span>
              </div>
              <!-- ${{financeData.recurring_amount + mainService.getCalculatedTransactionFee(financeData,financeData.recurring_amount) |number:'0.2-2'}} <i class="fa fa-info-circle m-l-5"  placement="right" tooltip='Your recurring amount includes a transaction fee.'></i></span> -->
              <div class="form-inside px-xl-4 px-0 form-mob-space recure-form recur_plan_pay">

                <div class="mb-2 mt-2 recurring_new">
                  <div class="position-relative d-inline-block recure-form-innr">
                    <span class="color_change text-black fs-24 fw-800 p-0 m-0 start_amount">
                      <span class="rec_amount">Recurring Amount:</span>
                      <div class="first_amount">
                        <span class="recuring-price text-black fw-800 d-inline-block" translate="no"
                          *ngIf="planInfo.contract_type == 6">
                          {{mainService.currency_data.display_logo}}
                          {{(planInfo
                          && planInfo.recurring_amount || planInfo.selected_plan.recurring_amount |
                          DynamicDecimalPipe:mainService.currency_data.currency_code)}}
                        </span>
                        <span class="recuring-price text-black fw-800 d-inline-block" translate="no"
                          *ngIf="planInfo.contract_type !=6">
                          {{mainService.currency_data.display_logo}} {{
                          ((planInfo && planInfo.recurring_amount || planInfo.selected_plan.recurring_amount) +
                          mainService.getCalculatedTransactionFee(planInfo,(planInfo.recurring_amount ||
                          planInfo.selected_plan.recurring_amount)))|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                        </span>
                      </div>
                      <div class="second_amount">
                        <span class="fs-24 fw-800 p-0 color_change d-inline-block"
                          *ngIf="planInfo.contract_type !=6">for
                          the next
                        </span>
                        <span class="month_count fs-24 fw-800 color-blue-black d-inline-block me-0"
                          *ngIf="planInfo && planInfo.selected_plan && !((planInfo.contract_type == 1 || planInfo.contract_type == 3 )  && planInfo.selected_plan.advance_interest_amount) && planInfo.contract_type !=6">
                          {{planInfo && planInfo.selected_plan &&
                          planInfo.selected_plan.month?(planInfo.selected_plan.month):'0'}}
                        </span>
                        <span class="month_count fs-24 fw-800 color-blue-black me-0 d-inline-block"
                          *ngIf="planInfo && (planInfo.contract_type == 1 || planInfo.contract_type == 3) && planInfo.contract_type !=6 && planInfo.selected_plan && planInfo.selected_plan.advance_interest_amount">
                          {{planInfo && planInfo.selected_plan &&
                          planInfo.selected_plan.month?(planInfo.selected_plan.month -
                          1): '0'}}
                        </span>
                        <span [class.deffred]="planInfo.contract_type == 6" class="mnth">{{planInfo.contract_type !=6 ?
                          ' months' : '
                          (During
                          Deferred)'}}
                        </span>
                      </div>
                    </span>
                    <span class="info_icon_btn px-0">
                      <!-- <img src="assets/svg/info_blue.svg" alt="" class="info_icon ms-2"> -->
                      <span class="info_icon ms-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 20 20" fill="none">
                          <path
                            d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                            stroke="#141616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9.375 9.375H10V13.75H10.625" stroke="#141616" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                            fill="#141616" />
                        </svg>
                      </span>

                      <span
                        class="tooltip_box d-none color-gray-1 card custom-amount custom_tool_recurring tooltip_box__modify"
                        *ngIf="planInfo"
                        [ngClass]="{'tool-deff': (planInfo && planInfo.contract_type ==6 && mainService.current_step == 3)}">
                        <div class="d-flex py-2 fs-14 align-items-center justify-content-between" *ngIf="planInfo ">
                          <div class="d-flex flex-column text-start">
                            <span class="color-gray fw-400">Recurring Amount</span>
                            <span class="color-gray fw-400" *ngIf="planInfo && planInfo.contract_type ==6">(During
                              Deferred)</span>
                          </div>
                          <div class="ps-2 text-end">
                            <span class="color-dblue fw-800 text-end text-nowrap"
                              style="max-width: calc(42%) !important;">{{mainService.currency_data.display_logo}}
                              {{(planInfo&& planInfo.recurring_amount ||
                              planInfo.selected_plan.recurring_amount)|
                              DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                          </div>
                        </div>
                        <div class="d-flex py-2 fs-14 align-items-center justify-content-between mmm"
                          *ngIf="planInfo && (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount)">
                          <span class="color-gray fw-400">Transaction Fee</span>
                          <span class="color-dblue fw-800 ps-2" style="max-width: calc(42%) !important;">
                            {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                            planInfo.selected_plan.recurring_amount &&
                            mainService.getCalculatedTransactionFee(planInfo,
                            planInfo.selected_plan.recurring_amount)?
                            (mainService.getCalculatedTransactionFee(planInfo,planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code):
                            '0.00'}}
                          </span>
                        </div>
                        <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                          *ngIf="planInfo && planInfo.contract_type ==6 && planInfo.selected_plan.month > planInfo.di_start_month">
                          <div class="d-flex flex-column text-start">
                            <span class="color-gray fw-400">Recurring Amount</span>
                            <span class="color-gray fw-400">(After Deferred)</span>
                          </div>
                          <div class="ps-2 text-end">
                            <span class="color-dblue fw-800"
                              style="max-width: calc(42%) !important;">{{mainService.currency_data.display_logo}}
                              {{(planInfo.next_recurring_amount ||
                              planInfo.selected_plan.next_recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                          </div>
                        </div>
                        <div class="d-flex py-2 fs-14 align-items-center justify-content-between nnn"
                          *ngIf="planInfo && planInfo.contract_type ==6 && (planInfo.selected_plan.month > planInfo.di_start_month)"
                          style="border-top: none !important">
                          <span class="color-gray fw-400">Transaction Fee</span>
                          <span class="color-dblue fw-800" style="max-width: calc(42%) !important;">
                            {{mainService.currency_data.display_logo}}
                            {{(mainService.getCalculatedTransactionFee(planInfo,(planInfo.next_recurring_amount ||
                            planInfo.selected_plan.next_recurring_amount),1)|DynamicDecimalPipe:mainService.currency_data.currency_code)}}
                          </span>
                        </div>

                        <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                          *ngIf="planInfo && planInfo.is_ar_contract && (planInfo && planInfo.plans_array && planInfo.plans_array[0].enrollment_fee)">
                          <span class="color-gray fw-400">Enrollment Fee</span>
                          <span class="color-dblue fw-800" style="max-width: calc(42%) !important;">
                            {{mainService.currency_data.display_logo}} {{planInfo && planInfo.plans_array &&
                            (planInfo.plans_array[0].enrollment_fee || planInfo.plans_array[0].enrollment_fee == 0) ?
                            (planInfo.plans_array[0].enrollment_fee|DynamicDecimalPipe:mainService.currency_data.currency_code) : '30'}}
                          </span>
                        </div>
                        <!-- <div class="d-flex py-2 fs-14 align-items-center justify-content-between hhh"
                                                      *ngIf="planInfo && planInfo.contract_type !=6 && (planInfo.threshold_amount < (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount || planInfo.is_ar_contract==1))">
                            <span class="color-gray fw-400">Transaction Fee</span>
                            <span class="color-gray fw-800" style="max-width: calc(42%) !important;">
                              {{mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount,1)}}</span>
                          </div> -->
                        <div class="d-flex py-2 fs-14 align-items-center justify-content-between"
                          *ngIf="planInfo && planInfo.contract_type != 6">
                          <span class="color-gray fw-400">Total Recurring Amount</span>
                          <span class="color-dblue fw-800" style="max-width: calc(42%) !important;">
                            {{ mainService.currency_data.display_logo }}
                            {{ (calculateTotalPayableAmount(
                            (planInfo?.recurring_amount || planInfo?.selected_plan?.recurring_amount),
                            mainService.getCalculatedTransactionFee(planInfo, (planInfo?.recurring_amount ||
                            planInfo?.selected_plan?.recurring_amount))
                            )) | DynamicDecimalPipe:mainService.currency_data.currency_code }}
                          </span>
                        </div>
                      </span>
                    </span>
                  </div>
                </div>



                <div class="pt-3 pb-0 recuring-plan">
                  <h6 class="color-black fs-16 fw-700 mb-1">Choose starting date for
                    recurring payments*</h6>
                  <div class="row">
                    <div class="col-12">
                      <!-- [disabled]="!add_button" [ngClass]="{button_class: !add_button}"
              [disabled]="!add_button" [ngClass]="{button_class: !add_button}" -->
                      <!-- Input select date -->
                      <!-- <div class="pointer custom-form-v5 flex-grow-1" class='custom-form-v5 mt-2'>
  
                      <input required name="dob" readonly class="pointer input_field form-control pt-4"
                        [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY' }" (click)="toggle(dobdp)"
                        (onShown)="onShowPicker($event)" #dobdp="bsDatepicker" bsDatepicker required
                        (blur)="add_button=false" [maxDate]="planInfo.max_date" [minDate]="planInfo.min_date"
                        [(ngModel)]="paymentDetails.recurringDate">
                      <label for="text" [ngClass]="[paymentDetails.recurringDate ? 'label-name':'']">
                        <span class="content-name_1 f-c-p-3">
                          Select Date
                        </span>
                        <span style="position: absolute;right: 0;transform: translate(-18px, 24px)"
                          (click)="dobdp.toggle()" [attr.aria-expanded]="dobdp.isOpen">
                          <img src="../../../../assets/svg/calendar2.svg" class="pointer" alt="">
                        </span>
                      </label>
                      <div
                        style="height: 240px;background-color: transparent;position: relative;z-index: 3;width: 100%;max-width: 240px;display: none;margin: 0px auto;"
                        class="display_class" *ngIf="add_button">
  
                      </div>
  
                    </div> -->

                      <div class="custom-form-v5 mt-2 birth-date">
                        <input #dob="ngModel" name="date_of_birth" class="pointer input_field px-3 pt-3 dob-input-field"
                          [max]="planInfo.max_date" [min]="planInfo.min_date" [(ngModel)]="paymentDetails.recurringDate"
                          (click)="picker.open()" (focus)="picker.open()" [matDatepicker]="picker" readonly>
                        <label style="bottom: -11px; left: 15px;" for="text" class="dob-label-name fs-12 text-start"
                          [ngClass]="[paymentDetails.recurringDate ? 'label-name':'']">
                          <span class="dob-content f-c-p-3 text--grey text-start">
                            Select Date
                          </span>
                          <span style="position: absolute;right: 0;transform: translate(-28px, 14px)">
                            <img src="assets/svg/calender-2.svg" />
                            <!-- <mat-datepicker-toggle matSuffix [for]="picker" class="d-none">
                          </mat-datepicker-toggle> -->
                            <mat-datepicker #picker startView="multi-year">
                            </mat-datepicker>
                            <!-- <img src="assets/svg/calender2.svg" class="pointer" alt=""> -->
                          </span>
                        </label>
                      </div>


                      <!-- Payment Add column -->
                      <div class="w-100 mt-md-2 mt-4" *ngIf="!recurring_source_id">
                        <!-- <h6 class="mt-4 fw-700 color-black fs-16 mb-2">
                          Recurring method <span class="mat-error">*</span>
                        </h6> -->

                        <div class="add_card_button_1 pt-2">
                          <button class="w-100 border-0 py-3" (click)="openModal_1(2,addNewPaymentMethodModal)"
                            id="add_card_button">
                            + Add Recurring Payment Method</button>
                        </div>
                      </div>

                      <!-- primary payment method  -->
                      <div class="w-100" *ngIf="recurring_source_id">
                        <h6 class="recurring_pay">
                          Recurring payment method*
                        </h6>

                        <div class="add_card_button_1 add_card_button_2 mt-2 recure-payment position-relative">
                          <form
                            class="d-flex mb-2 align-items-center justify-content-between px-3 py-2 card_show_box mb-0">
                            <span for="'card'+i" class="mb-0 color-dblue fs-14 fw-700 pe-2">
                              <img style="width:24px;" class="me-2"
                                [src]="getMyCard(recurring_source_id,'recurring_sources') && getMyCard(recurring_source_id,'recurring_sources').payment_source == 'Bank' ? 'assets/svg/bank.svg' : getMyCard(recurring_source_id,'recurring_sources').brand?'assets/svg/card-type/'+getMyCard(recurring_source_id,'recurring_sources').brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                                *ngIf="getMyCard(recurring_source_id,'recurring_sources') && (getMyCard(recurring_source_id,'recurring_sources').brand);else no_card " />
                                <!-- getMyCard(recurring_source_id,'recurring_sources') && (getMyCard(recurring_source_id,'recurring_sources').brand=='MasterCard' || getMyCard(recurring_source_id,'recurring_sources').brand=='Discover' || getMyCard(recurring_source_id,'recurring_sources').brand=='JCB' || getMyCard(recurring_source_id,'recurring_sources').brand=='Visa' || getMyCard(recurring_source_id,'recurring_sources').brand=='American Express' || getMyCard(recurring_source_id,'recurring_sources').payment_source == 'Bank');else no_card  -->
                              <ng-template #no_card>
                                <img style="width:24px;" [src]="'assets/svg/card-type/no_card.svg'">
                              </ng-template>
                              XXXX XXXX {{getMyCard(recurring_source_id,'recurring_sources') &&
                              getMyCard(recurring_source_id,'recurring_sources').payment_source_type != 1 ?
                              "XXXX ":""}}{{getMyCard(recurring_source_id,'recurring_sources') &&
                              getMyCard(recurring_source_id,'recurring_sources').last4}}
                            </span>

                            <span>
                              <div class="custom-radio-box position-relative custom-radio-checkobx">
                                <input type="radio" name="recurring_card" checked [value]="recurring_source_id" />
                                <label class="radio-label"></label>
                              </div>
                            </span>
                          </form>
                          <!-- <div class="offer-strip"  *ngIf="(opened_step == 1 || opened_step == 2) && planInfo && planInfo.enrollment_waiver == 1 && getMyCard(recurring_source_id,'recurring_sources').payment_source_type == 1" style="position: absolute;top: 38px;left: 16px;width: 100%;">
                  Offer available: Get ${{planInfo.plans_array[0].enrollment_fee ?
                  planInfo.plans_array[0].enrollment_fee : '30'}} off on your contract enrollment fee!
                  </div> -->
                          <div class="mt-1 w-25">
                            <span class="fw-700 color-blue pointer"
                              (click)="openModal_1(2,addNewPaymentMethodModal);gettingCard = false">+
                              Update</span>
                          </div>
                        </div>
                      </div>

                      <!-- backup payment mehtod  -->
                      <div
                        *ngIf="!(getNumber(planInfo.selected_payment_matrix.recurring_type) == 1 && getNumber(planInfo.selected_payment_matrix.backup_type) == 1)">
                        <h6 class="recurring_pay" *ngIf="backup_source_id">
                          Backup Payment Method
                        </h6>
                        <div class="add_backup_card mt-3" *ngIf="!backup_source_id">
                          <button class="w-100 button-login-100 border-0" [disabled]="!recurring_source_id"
                            [ngStyle]="{'cursor': !recurring_source_id ? 'no-drop' :'pointer', 'background-color': !recurring_source_id? '#f8f9fa' :'#E9FAFF', 'color': !recurring_source_id? '#808080' :'#017A9F'}"
                            (click)="openModal_1(3,addNewPaymentMethodModal)">+ Add Backup Payment Method</button>
                        </div>

                        <div class="add_card_button_1 add_card_button_2 mt-2" *ngIf="backup_source_id">
                          <form
                            class="d-flex mb-2 align-items-center justify-content-between px-3 py-2 card_show_box mb-0">
                            <span for="'card'+i" class="mb-0 color-dblue fs-14 fw-700 pe-2">
                              <img style="width:24px;" class="me-2"
                                [src]="getMyCard(backup_source_id,'backup_sources') && getMyCard(backup_source_id,'backup_sources').payment_source == 'Bank' ? 'assets/svg/bank.svg' : getMyCard(backup_source_id,'backup_sources').brand?'assets/svg/card-type/'+getMyCard(backup_source_id,'backup_sources').brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                                *ngIf="getMyCard(backup_source_id,'backup_sources') && (getMyCard(backup_source_id,'backup_sources').brand);else no_card" />
                                <!-- getMyCard(backup_source_id,'backup_sources') && (getMyCard(backup_source_id,'backup_sources').brand=='MasterCard' || getMyCard(backup_source_id,'backup_sources').brand=='Discover' || getMyCard(backup_source_id,'backup_sources').brand=='JCB' || getMyCard(backup_source_id,'backup_sources').brand=='Visa' || getMyCard(backup_source_id,'backup_sources').brand=='American Express' || getMyCard(backup_source_id,'backup_sources').payment_source == 'Bank');else no_card -->
                              <ng-template #no_card>
                                <img style="width:24px;" class="me-2" [src]="'assets/svg/card-type/no_card.svg'">
                              </ng-template>
                              XXXX XXXX {{getMyCard(recurring_source_id,'backup_sources') &&
                              getMyCard(backup_source_id,'backup_sources')?.payment_source_type != 1 ? "XXXX
                              ":""}}{{getMyCard(backup_source_id,'backup_sources') &&
                              getMyCard(backup_source_id,'backup_sources').last4}}
                            </span>
                            <div class="d-flex align-items-center">
                              <span>
                                <img class="me-2" src="assets/svg/delete-icon.svg" style="width: 30px; cursor: pointer;"
                                  (click)="backup_source_id = null">
                              </span>

                              <div class="custom-radio-box position-relative custom-radio-checkobx">
                                <input type="radio" name="recurring_card" checked [value]="recurring_source_id" />
                                <label class="radio-label"></label>
                              </div>

                            </div>
                          </form>
                          <div class="mt-1 w-25" *ngIf="backup_source_id">
                            <span class="fw-700 color-blue pointer"
                              (click)="openModal_1(3,addNewPaymentMethodModal);gettingCard = false">+
                              Update</span>
                          </div>
                        </div>



                        <div class="w-100 color-gray-1 mt-4 notes_section">
                          <span class="font-weight-bold fs-14 color-gray">
                            Note:
                          </span>
                          <br>
                          <ul>
                            <li>If the selected payment method fails, we will attempt to charge your backup card.</li>
                            <!-- <br> -->
                            <!-- <li >As part of our card verification process <span class="notranslate">{{mainService.currency_data.display_logo}}1 </span>will be deducted which will be refunded once your card has been validated.</li> -->
                            <li hideIfDecimal>You will be charged <span
                                class="notranslate">{{mainService.currency_data.display_logo}}1 </span> or 1%(whichever
                              is higher) extra transaction fee if use a non-{{mainService.currency_data.country_code}}
                              debit/credit card.</li>
                          </ul>
                        </div>
                      </div>


                      <div class="button_continue_payment_method py-0  ">
                        <button button-primary-auth class="px-5 plan-btn-changes blue-btn-v2"
                          (click)="signature=null;switchForm()" [disabled]="!recurring_source_id"
                          id="Continue2">Continue</button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- current step == 4 -->
            <ng-container *ngIf="mainService.current_step == 4 && planInfo">
              <div class="input_containers_head fw-700 fs-16 mb-0 color-gray px-4 dsk-hide">
                <div class="button_back_inside">
                  <span [ngClass]="mainService.current_step == 5 ? 'fivesteps' : ''">
                    <span class="left-back-btn" (click)="changeScreen()">
                      <!-- <img src="assets/png/arrow-left.png" alt=""> -->
                      <!-- Previous Step -->
                    </span>
                  </span>
                </div>
                <span class="data_personal"> Make Payment</span>
              </div>
              <div class="form-inside px-xl-4 px-2 form-mob-space payable-info">

                <div class="recurring_new_today" *ngIf="split_request_data && !split_request_data[0]?.ar_flow_immediate">
                  <h2 class="mt-3 mb-0 fw-800 fs-24">
                    <div>
                      <span class="text-black fs-24 fw-800 d-inline-block recuring-price mt-lg-0">
                        <span translate="no">{{mainService.currency_data.display_logo}} {{
                          planInfo.selected_plan.to_pay_today |
                          DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
                      </span>
                      <span class="total_pay_today">total Payable Today</span>
                    </div>

                    <button class="info_icon_btn service-amount-btn"
                      *ngIf="planInfo && planInfo.selected_plan && planInfo.selected_plan.to_pay_today > 0">
                      <!-- <img src="assets\png\Icons.png" alt="" class="info_icon_btn_img"> -->
                      <span class="info_icon_btn_img">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 20 20" fill="none">
                          <path
                            d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                            stroke="#141616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M9.375 9.375H10V13.75H10.625" stroke="#141616" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                            fill="#141616" />
                        </svg>
                      </span>
                      <span class="tooltip_box">
                        <div class="col-12 mx-auto px-0 mt-3 mb-0" *ngIf="planInfo">
                          <ul style="list-style-type: none;" class="px-0 service_viewer no_scroll pt-lg-0 pt-4">
                            <li class="d-flex align-items-center justify-content-between flex-wrap service_list_item"
                              *ngIf="contract_type!=3">
                              <span class="color-gray fs-14">
                                {{planInfo && planInfo.is_ar_contract == 1 ? 'Upfront Payment' :
                                split_request_data && split_request_data[0].contract_type
                                == 1 ? "Recurring Amount" :'Upfront Fee'}}
                              </span>
                              <span class="fw-700 all-data fs-14">
                                {{mainService.currency_data.display_logo}} {{planInfo && planInfo.selected_plan &&
                                planInfo.selected_plan.advance_interest_amount?(planInfo.selected_plan.advance_interest_amount):
                                '0.00'}}
                              </span>
                            </li>
                            <li class="d-flex align-items-center justify-content-between service_list_item">
                              <span class="color-gray fs-14">
                                Enrollment Fee
                                <img src="../../../../assets/svg/offer.svg" width="20px"
                                  tooltip="{{'If you instantly pay your payment today using bank, you will get ' + mainService.currency_data.display_logo + planInfo.plans_array[0].enrollment_fee + 'off on your contract enrollment fee!'}}"
                                  *ngIf="planInfo && planInfo.plans_array && planInfo.plans_array[0] && planInfo.enrollment_waiver == 1 && getNumber(planInfo.selected_payment_matrix.primary_type) == 3 && planInfo.enrollment_enabled == 0">
                              </span>
                              <del *ngIf="is_waived">
                                <span class="float-end font-weight-bold  f-s-14 text-muted text-colr"
                                  [ngClass]="[getMyCard(dp_source_id,'primary_sources') && getMyCard(dp_source_id,'primary_sources').payment_source_type == 1 ? 'line-through' : '']">
                                  {{mainService.currency_data.display_logo}} {{planInfo && planInfo.plans_array &&
                                  planInfo.plans_array[0].enrollment_fee ?
                                  planInfo.plans_array[0].enrollment_fee : '30'}}</span>
                              </del>
                              <span class="float-end font-weight-bold  f-s-14 text-colr" *ngIf="!is_waived">
                                {{mainService.currency_data.display_logo}} {{planInfo && planInfo.plans_array &&
                                planInfo.plans_array[0].enrollment_fee ||
                                planInfo && planInfo.plans_array && planInfo.plans_array[0].enrollment_fee ==0 ?
                                planInfo.plans_array[0].enrollment_fee : '30'}}
                              </span>
                            </li>
                            <li class="d-flex align-items-center justify-content-between service_list_item"
                              *ngIf="!is_ar_contract && planInfo.downpayment_amount > 0">
                              <span class="color-gray fs-14">
                                {{planInfo && planInfo.is_ar_contract == 1 ? 'Partial Payments' : 'Down Payment'}}
                              </span>
                              <span class="float-end font-weight-bold  f-s-14 text-colr">
                                {{mainService.currency_data.display_logo}} {{planInfo.downpayment_amount|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                              </span>
                            </li>
                            <li class="d-flex align-items-center justify-content-between service_list_item"
                              *ngIf="split_request_data && split_request_data[0].contract_type !== 3">
                              <span class="color-gray fs-14">
                                Transaction Fee
                              </span>
                              <span *ngIf="planInfo && (planInfo.selected_plan && planInfo.is_arv2 == 0)"
                                class="float-end font-weight-bold  f-s-14 text-colr">{{mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount,1)}}
                                / payment</span>
                              <span *ngIf="planInfo && (planInfo.selected_plan && planInfo.is_arv2 == 1)"
                                class="float-right font-weight-bold  f-s-14 text-colr">{{mainService.getTransactionFee(planInfo,planInfo.selected_plan.next_recurring_amount,1)}}
                                / payment</span>
                            </li>
                          </ul>
                        </div>
                      </span>
                    </button>
                  </h2>
                </div>

                <div class="Select_payment_method pt-4" *ngIf="split_request_data && !split_request_data[0]?.ar_flow_immediate && (planInfo && planInfo.selected_plan && planInfo.selected_plan.total_payable_amount !=0)">
                  <span class="recurring_pay" *ngIf="dp_source_id">{{!dp_source_id ? "Select" :
                    "Today's"}}
                    payment method*</span>

                  <div class="add_backup_card mt-3" *ngIf="!dp_source_id ">
                    <button class="w-100 button-login-100 border-0 py-3"
                      (click)="openModal_1(1,addNewPaymentMethodModal)">+
                      Add Payment Method</button>
                  </div>


                  <ng-container *ngIf="dp_source_id">

                    <div class="add_card_button_1 add_card_button_2 mt-2">
                      <form class="d-flex mb-0 align-items-center justify-content-between px-3 py-2 card_show_box mb-0">
                        <span for="" class="mb-0 color-dblue fs-14 fw-700 pe-2" id="recurring_today">
                          <img style="width:24px;" class="me-2"
                            [src]="getMyCard(dp_source_id,'primary_sources') && getMyCard(dp_source_id,'primary_sources').payment_source == 'Bank' ? 'assets/svg/bank.svg' : getMyCard(dp_source_id,'primary_sources') && getMyCard(dp_source_id,'primary_sources').brand?'assets/svg/card-type/'+getMyCard(dp_source_id,'primary_sources').brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                            *ngIf="getMyCard(dp_source_id,'primary_sources') && getMyCard(dp_source_id,'primary_sources').brand;else no_card" />
                            <!-- getMyCard(dp_source_id,'primary_sources') && (getMyCard(dp_source_id,'primary_sources').brand=='MasterCard' || getMyCard(dp_source_id,'primary_sources').brand=='Discover' || getMyCard(dp_source_id,'primary_sources').brand=='JCB' || getMyCard(dp_source_id,'primary_sources').brand=='Visa' || getMyCard(dp_source_id,'primary_sources').brand=='American Express' || getMyCard(dp_source_id,'primary_sources').payment_source == 'Bank');else no_card -->
                          <ng-template #no_card>
                            <img style="width:24px;" class="me-2" [src]="'assets/svg/card-type/no_card.svg'">
                          </ng-template>
                          XXXX XXXX {{getMyCard(dp_source_id,'primary_sources') &&
                          getMyCard(dp_source_id,'primary_sources').payment_source_type != 1 ? "XXXX
                          ":""}}{{getMyCard(dp_source_id,'primary_sources') &&
                          getMyCard(dp_source_id,'primary_sources').last4}}
                        </span>
                        <span>
                          <div class="custom-radio-box position-relative custom-radio-checkobx">
                            <input type="radio" name="dp_card" checked [value]="dp_source_id" />
                            <label class="radio-label"></label>
                          </div>
                        </span>
                      </form>
                      <div class="mt-3 w-25">
                        <span class="fw-700" role="link"
                          (click)="openModal_1(1,addNewPaymentMethodModal)">+Update</span>
                      </div>
                    </div>


                  </ng-container>
                </div>

                <div *ngIf="split_request_data && split_request_data[0]?.ar_flow_immediate">
                  <ng-container *ngTemplateOutlet="paymentArFlow"></ng-container>
                </div>

                <!-- card display ends -->
                <div class="signature_pad_block mt-3">

                  <div class="p-0 col-12 overflow-hidden mt-3" #canvasDiv id="canvasDiv">
                    <!-- <app-signature-pad (signatureSaved)="drawComplete($event)" [parentWidth]="getParentDivWidth()" ></app-signature-pad> -->
                    <app-generate-signature name="signature" #signaturePad [autoFillName] = "patientData['patient_first_name'] + ' ' + patientData['patient_last_name']" ></app-generate-signature>
                    <!-- <span class="eraser position-absolute" (click)="clearSign()" placement="right" tooltip='Clear'>
                      <img src="assets/svg/eraser.svg" alt="">
                    </span> -->
                    <!-- <span class="fw-700 fs-14 text--grey position-absolute" placement="left"
                      style="bottom: 8px; left: 8px;">
                      Your Signature
                    </span> -->
                  </div>
                </div>

                <div class="box--wrapper" [class.checked]="check_business_terms">
                  <h5>I agree to the following:</h5>
                  <div class="before">
                    <!-- <input default-checkbox type="checkbox" class="form-check-input mt-2" name="terms" [(ngModel)]="terms" id="terms"> -->
                    <label for="terms">
                    <span id="pre-custom">I've read</span> & agreed to the
                      <span *ngIf="show_closure_form">
                        <a href="javascript:void(0)" target="_blank" [routerLink]="['/tila']"
                          class="custom-anchor fw-700"> TILA
                          Disclosure</a>,
                      </span>
                      <span>
                        <a target="_blank" [routerLink]="['/consentForm']" [queryParams]="{token: contractToken}"
                          style="line-break: auto;" class="custom-anchor fw-700">
                          Payment Authorization Agreement&nbsp;and&nbsp;HIPAA Disclosure
                        </a>.
                      </span>


                    </label>
                  </div>
                  <div class="before"
                    *ngIf="split_request_data && split_request_data[0].buss_terms_link && split_request_data[0].show_buss_terms">
                    <!-- <input default-checkbox type="checkbox" class="form-check-input mt-2" name="check_business_terms"
                      [(ngModel)]="check_business_terms" id="check_business_terms"> -->
                    <span id="pre-custom"></span>
                    <label for="check_business_terms">
                      I hereby read & accept the terms and conditions of
                      <a href="javascript:void(0)"
                        (click)="goToLink(split_request_data && split_request_data[0].buss_terms_link)"
                        *ngIf="split_request_data && split_request_data[0].buss_terms_link && split_request_data[0].show_buss_terms"
                        rel="noopener noreferrer" role="link" class="color-dblue">{{split_request_data &&
                        split_request_data[0].practice_name
                        ||
                        (split_request_data[0].doctor_first_name + ' ' + split_request_data[0].doctor_last_name) ||
                        'Business
                        Terms'}}</a>.
                    </label>
                  </div>
                  <div class="before">
                    <label>
                    By proceeding, I acknowledge and agree that my electronic signature carries the same legal validity and
                    enforceability
                    as a handwritten signature for this contract/payment.
                    </label>
                  </div>
                  <div class="before">
                    <label>
                      I've read and agree that I have a 3-business-day right to rescind this payment plan and receive only the upfront payment back. After this period, only the business holds the authority to cancel the contract, and no further refunds will be provided, and I remain responsible for payments under the agreement.
                    </label>
                  </div>
                  <div class="clicking--area" (click)="check_business_terms = !check_business_terms"></div>
                </div>

                <!--button continue -->
                <div class="button_continue btn-confirm mt-0">
                  <!-- createContract -->
                  <button button-primary-auth class="px-5 fs-16 adding-bnk" (click)="uploadBusinessSignature()"
                    [disabled]="(((patientData && patientData.total_automation_business && patientData.total_automation_business.length == 0) ? !mainService.signature:'') || !check_business_terms)" id="Confirm1">Make Payment</button>
                </div>

                <div hideIfDecimal class="w-100 mt-4"
                  *ngIf="planInfo && planInfo.selected_plan && planInfo.selected_plan.total_payable_amount !=0">
                  <!-- Note -->
                  <div class="w-100 color-gray-1 mt-4 notes_section">
                    <span class="font-weight-bold fs-14 color-gray">
                      Note:
                    </span>
                    <ul>
                      <!-- <li>As part of our card verification process <span
                          class="notranslate">{{mainService.currency_data.display_logo}}1 </span>will be deducted which will be refunded once
                        your card has been validated.</li> -->
                      <li>You will be charged <span class="notranslate">{{mainService.currency_data.display_logo}}1
                        </span> or 1%(whichever is
                        higher) extra transaction fee if use a non-{{mainService.currency_data.country_code}}
                        debit/credit card.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- current step == 5 -->
            <ng-container *ngIf="mainService.current_step == 5">
              <div class="form-inside px-xl-4 px-2 onestep-modal" id="fully-successfull">
                <div class="modal-body p-0">
                  <div class="modal-data">
                    <!-- <div class="success-animation success-md-animation mt-5">
                    <img src="assets\png\check-icon.png" alt="">
                  </div> -->
                    <div class="head_content py-4 mb-md-3 mb-0 h5 fw-700 fs-18">
                      Your payment has been made successfully.
                      <p class="fs-12 fw-700 contract_id_grey"
                        *ngIf="split_request_data && split_request_data.length > 0">
                        CONTRACT ID: {{split_request_data && split_request_data[0]['contract_code'] || contract_code ||
                        'Not Available'}}
                      </p>
                    </div>
                  </div>

                  <div class="body_content px-0">
                    <div class="w-100 pay-plan p-0">
                      <div class="plans--commit d-flex align-items-center flex-grow-1">
                        <div class="flex-grow-1">
                          <p class="plans-commit-text m-0 fs-18 fw-400 mb-1 text-start">
                            Payment Plan
                          </p>
                          <p class="fs-20 py-1 fw-800 m-0 text-start plans-commit--price" *ngIf="planInfo">
                            {{mainService.currency_data.display_logo}} {{planInfo && planInfo.treatment_amount ?
                            ((planInfo.treatment_amount - (planInfo.downpayment_amount || 0))|DynamicDecimalPipe:mainService.currency_data.currency_code) :'0.00'}}</p>
                        </div>
                      </div>
                      <div class="plans--commit plan-left-border info-card-two d-flex align-items-center flex-grow-1"
                        *ngIf="planInfo && planInfo.contract_type != 6">
                        <div class="flex-grow-1">
                          <p class="plans-commit-text mb-1 fs-18 fw-400 text-start">{{planInfo && planInfo.selected_plan
                            &&
                            planInfo.selected_plan.month}} Months</p>
                          <div class="per_month py-1 card-track2 text-start fs-20 fw-800 plans-commit--price">
                            {{mainService.currency_data.display_logo}} {{planInfo && (planInfo.recurring_amount ||
                            (planInfo.selected_plan.recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code))}}
                            <span class="card-track1 fs-14 fw-400 plans-commit--month">per month</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex-grow-1" *ngIf="planInfo && planInfo.contract_type == 6">
                        <div class="flex-grow-1 plans--commit-innr">
                          <div class="flex-grow-1 plans--commit plan-left-border d-flex align-items-center">
                            <div class="flex-grow-1">
                              <p class="plans-commit-text mb-1 fs-18 fw-400 text-start">First
                                {{planInfo.deferred_duration}}
                                Months</p>
                              <div class="per_month py-1 fs-20 fw-800 text-start fw-800 plans-commit--price">
                                {{mainService.currency_data.display_logo}} {{planInfo && (planInfo.recurring_amount ||
                                (planInfo.selected_plan.recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code))}}
                                <span class="color-gray-2 fw-400 fs-14 text-start fw-400 plans-commit--month">/
                                  month</span>
                              </div>
                            </div>
                          </div>

                          <div class="flex-grow-1 plans--commit plan-left-border d-flex align-items-center">
                            <div class="flex-grow-1">
                              <p class="plans-commit-text mb-1 fs-18 fw-400 text-start">Remaining Months</p>
                              <div class="per_month py-1 fs-20 fw-800 text-start fw-800 plans-commit--price">
                                {{mainService.currency_data.display_logo}} {{planInfo && (planInfo.next_recurring_amount
                                ||
                                (planInfo.selected_plan.next_recurring_amount|DynamicDecimalPipe:mainService.currency_data.currency_code))}}
                                <span class="color-gray-2 fw-400 fs-14 text-start fw-400 plans-commit--month">/
                                  month</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="w-100 recurring">
                      <span class="card-body first-occur">First Recurring Payment Date</span>
                      <p class="date_column h3 mt-2 fw-700">{{paymentDetails.recurringDate | date:'MM/dd/yyyy'}}
                      </p>
                    </div>

                    <div class="botton_continue">
                      <button button-primary-auth class="px-lg-5 px-4 adding-bnk blue-btn-v2"
                        (click)="goToCustomerDetails()">Continue</button>
                    </div>

                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <footer class="footer text-center d-none">
        <div class="col-12 mt-2 mt-sm-0 Powered form-powerd--wrap">
          <!-- <span
            *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && !mainService.contractSupport"
            class="footer-help--wrap--v2">
            <span class="m-0 f-s-16 small-mob color-gray fw-700">
              <a class="" href="https://www.credee.com/support" target="_blank"><svg xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <g clip-path="url(#clip0_8693_20253)">
                    <path
                      d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 16C11.7348 16 11.4804 16.1054 11.2929 16.2929C11.1054 16.4804 11 16.7348 11 17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17C13 16.7348 12.8946 16.4804 12.7071 16.2929C12.5196 16.1054 12.2652 16 12 16ZM12 6.5C11.0386 6.5 10.1166 6.88192 9.43674 7.56174C8.75692 8.24156 8.375 9.16359 8.375 10.125C8.375 10.3902 8.48036 10.6446 8.66789 10.8321C8.85543 11.0196 9.10978 11.125 9.375 11.125C9.64022 11.125 9.89457 11.0196 10.0821 10.8321C10.2696 10.6446 10.375 10.3902 10.375 10.125C10.3753 9.83004 10.4559 9.54072 10.6082 9.28809C10.7604 9.03545 10.9786 8.82902 11.2392 8.69092C11.4998 8.55282 11.7932 8.48827 12.0877 8.50419C12.3822 8.52011 12.6669 8.61589 12.9111 8.78127C13.1553 8.94666 13.35 9.1754 13.4741 9.44297C13.5982 9.71054 13.6472 10.0069 13.6157 10.3001C13.5843 10.5934 13.4736 10.8726 13.2955 11.1078C13.1175 11.3429 12.8788 11.5252 12.605 11.635C11.929 11.905 11 12.597 11 13.75V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.756 13.05 13.634 13.261 13.53L13.348 13.49C14.1288 13.1759 14.776 12.6 15.1787 11.8609C15.5814 11.1219 15.7145 10.2658 15.5551 9.43938C15.3958 8.61299 14.9539 7.86776 14.3052 7.33147C13.6566 6.79518 12.8416 6.50122 12 6.5Z"
                      fill="#20A9D3" />
                  </g>
                  <defs>
                    <clipPath id="clip0_8693_20253">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg> Need Help</a>
            </span>
          </span> -->
          <div class="w-100 small-mob mt-2 mb-3">
            <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                  src="assets/svg/logo_colored.svg"></span></span>
          </div>
        </div>
        <div class="text-big">
          <span
            *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
            <span class="m-0 f-s-16 small-mob color-gray text-capitalize">
              In case of any additional queries, please contact your service provider
              <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
                '+planInfo.doctor_last_name | titlecase}}</b>
              <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
              <a class="text-bold"
                *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
                href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
                {{(planInfo && planInfo.practice_mobile ? (planInfo.practice_mobile) :
                (planInfo.doctor_phone) ? (planInfo.doctor_phone) :
                (planInfo.doctor_mobile)) | phoneNumber : "N.A"}}
              </a>
            </span>

          </span>
          <span class="small-mob footer-terms--date">
            &copy; {{date | date:'yyyy'}} - Credee
          </span>
        </div>
      </footer>


    </div>


  </div>
  <footer class="footer d-none d-md-block fixed-bottom mb-3" data-screenshot-exclude>
    <div class="mb-2 text-center text-muted fs-16 px-3 footer-help-line"
      *ngIf="mainService.support_data && mainService.support_data.support_mobile">
      Need Help? &nbsp; Call us at <span><a highlight-color
          href="tel:{{mainService.support_data.support_mobile}}">{{mainService.support_data.support_mobile}}</a></span>,
      or <span><a highlight-color href="https://www.credee.com/support" target="_blank">Click here</a></span> to Request
      a Callback.
    </div>
    <div class="d-flex justify-content-center align-items-center flex-wrap py-1 px-3">
      <div class="mt-2 mt-sm-0 me-2 Powered">
        <div class="w-100 small-mob text-muted">
          <span class="fs-14 ">Powered By <span class="text-primary ms-1"><img
                src="assets/svg/logo_colored.svg"></span></span>
        </div>
      </div>
      <div class="text-big">
        <span *ngIf="planInfo && (planInfo.practice_name || planInfo.doctor_first_name) && mainService.contractSupport">
          <span class="m-0 f-s-16 small-mob color-gray text-capitalize">
            In case of any additional queries, please contact your service provider
            <b>{{planInfo && planInfo.practice_name ? planInfo.practice_name : planInfo.doctor_first_name+'
              '+planInfo.doctor_last_name | titlecase}}</b>
            <span *ngIf="(planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"> at </span>
            <a class="text-bold"
              *ngIf="planInfo && (planInfo.practice_mobile || planInfo.doctor_phone || planInfo.doctor_mobile)"
              href="tel:{{planInfo && planInfo.practice_mobile ?planInfo.practice_mobile:planInfo.doctor_phone}}">
              {{(planInfo && planInfo.practice_mobile ? (planInfo.practice_mobile) :
              (planInfo.doctor_phone) ? (planInfo.doctor_phone) :
              (planInfo.doctor_mobile)) | phoneNumber : "N.A"}}
            </a>
          </span>
  
        </span>
  
        <span class="small-mob text-muted">
          &copy; {{date | date:'yyyy'}} - Credee
        </span>
      </div>
    </div>
  </footer>

</div>


<!-- modal add payment card -->
<div bsModal #addNewPaymentMethodModal="bs-modal" [config]="{ignoreBackdropClick:true}" class="modal" tabindex="-1"
  role="dialog" (onShow)="AddStripeElement('add_new_card');" aria-labelledby="mySmallModalLabel" aria-hidden="true"
  (onHide)="RemoveStripeElement('add_new_card');">
  <div class="modal-dialog  modal-dialog-centered customModal modal-md"
    [ngClass]="dataEnter ? 'side_modal' : 'close_modal'">
    <div class="modal-content p-4">
      <div class="modal-header-payment pt-0 mb-3">
        <h4 class="modal-title color-gray text-capitalize">Add {{opened_step == 2 ? 'Recurring' : opened_step == 3
          ? 'Backup' : ''}} Payment Method</h4>
        <button type="button" class="close" aria-label="Close" role="button_close" (click)="closeBank()"><img
            src="assets/svg/close-circle.svg" alt=""></button>
      </div>
      <div class="modal-body p-0">
        <div class="d-flex mb-3 card_bank">
          <div class="px-3 pt-sm-0"
            *ngIf="planInfo && ((opened_step == 2 &&  (planInfo.selected_payment_matrix && (getNumber(planInfo.selected_payment_matrix.recurring_type) == 2 || getNumber(planInfo.selected_payment_matrix.recurring_type) == 3)))
            
            || (opened_step == 3 && planInfo.selected_payment_matrix && (getNumber(planInfo.selected_payment_matrix.backup_type) == 2 || getNumber(planInfo.selected_payment_matrix.backup_type) == 3))
            
            || (opened_step == 1 && planInfo.selected_payment_matrix && (getNumber(planInfo.selected_payment_matrix.primary_type) == 2 || getNumber(planInfo.selected_payment_matrix.primary_type) == 3)))">

            <button
              (click)="add_bank_step = 'card';selected_card=''; showElement = false;existing(buttonSelectedType.cardTab);"
              class="button-login-100 -w-100 py-2 mt-md-0 mt-2"
              [ngClass]="[add_bank_step == 'card' ? '' : ' color-gray bg_gray']" id="card_add">
              <span>
                <img [src]="[add_bank_step == 'card' ? 'assets/svg/card.svg' : 'assets/svg/card_fade.svg']" alt=""
                  srcset="">
                <span [ngClass]="[add_bank_step == 'card' ? '' : 'color-gray']" class="vam">
                  Card
                </span>
              </span>
            </button>
          </div>

          <!-- bank  -->
          <div
            *ngIf="planInfo && patientData  && patientData['show_ach'] == 1 && ((opened_step == 2 &&  (planInfo.selected_payment_matrix && planInfo.selected_payment_matrix.recurring_type == 1 || (planInfo.selected_payment_matrix.recurring_type) == 3)) || 

            (opened_step == 3 && (planInfo.selected_payment_matrix && ((planInfo.selected_payment_matrix.backup_type) == 1 || (planInfo.selected_payment_matrix.backup_type) == 3)) && !(getMyCard(recurring_source_id,'recurring_sources') && getMyCard(recurring_source_id,'recurring_sources').payment_source == 'Bank' && opened_step == 3)) || 

            (opened_step == 1 && planInfo.selected_payment_matrix && ((planInfo.selected_payment_matrix.primary_type) == 1 || (planInfo.selected_payment_matrix.primary_type) == 3)))">

            <button
              (click)="add_bank_step = 'bank';selected_card=''; showElement = false; existing(buttonSelectedType.bank);"
              class="button-login-100 w-100 py-2 mt-md-0 mt-2 ms-3"
              [ngClass]="[add_bank_step == 'bank' ? '' : ' color-gray bg_gray']">
              <span>
                <img [src]="[add_bank_step == 'bank' ? 'assets/svg/bank_fade.svg' : 'assets/svg/bank.svg']" alt=""
                  srcset="">
                <span [ngClass]="[add_bank_step == 'bank' ? '' : 'color-gray']" class="vam">
                  Bank
                </span>
                <img src="../../../../assets/svg/offer.svg" width="20px"
                  tooltip="{{'If you instantly pay your payment today using bank, you will get ' + mainService.currency_data.display_logo + planInfo.plans_array[0].enrollment_fee + 'off on your contract enrollment fee!'}}"
                  *ngIf="(opened_step == 1 || opened_step == 2) && planInfo.plans_array[0] && planInfo.enrollment_waiver == 1 && getNumber(planInfo.selected_payment_matrix.primary_type) == 3 && planInfo.enrollment_enabled == 0">
              </span>
            </button>
          </div>
          <!-- <div class="col-12 my-col" [ngClass]="[add_bank_step == 'card' ? '' : 'd-none']">
            <app-generate-stripe-token [address]="{}" [buttonClickedSubject]="buttonClickedSubject"
              (onFocussed)="CardFocussed()" [elementId]="'add_new_card'"
              (cardResponse)="CatchStripeTokenForNewCard($event, addNewPaymentMethodModal)" class="col-12 my-col"
              [show_save_card]="false" [payment_failed_first]="dp_last4" [show_address]="false">
            </app-generate-stripe-token>
          </div> -->
        </div>
        <!-- <ng-container *ngIf="add_bank_step == 'bank'">
          <hr class="mt-3">
        </ng-container> -->
        <div class="pointer"
          *ngIf="add_bank_step != 'bank' && ( ( opened_step == 2) || (opened_step == 3) || (opened_step == 1)) &&  (primary_card_added || recurring_card_added || backup_card_added)">
          <input type="radio" name="existing" id="list_card" [checked]="validValue" (change)="validValue = !validValue">
          <label for="list_card" (click)="existing(buttonSelectedType.existing)">
            <span style="font-weight: 600;font-size: 17px;" class="ps-2">Select existing Cards
            </span>
          </label>
        </div>

        <!-- Add Cards Filed Start  -->
        <div class="add_card_button_1 opened_step_1" style="max-height:200px;overflow-y: auto;"
          *ngIf="(opened_step == 1 && validValue)">
          <div class="card-block mb-2" *ngFor="let source of patientData?.primary_sources">
            <label class="col-12 card_show_box mb-0 "
              *ngIf="(source &&  source.payment_source_type == 1 && add_bank_step == 'bank') || (source.payment_source_type !== 1 && add_bank_step == 'card')"
              [ngClass]="{'primary-card-label': !(source && source.payment_source_type == 1 && source.source_id > 0)}"
              [ngStyle]="{'padding-bottom': !(source && source.payment_source_type == 1 && source.source_id > 0 ? '7px' : '')}">
              <div class="d-flex align-items-center h-100" [ngClass]="[(planInfo.enrollment_waiver == 1 && getNumber(planInfo.selected_payment_matrix.primary_type) == 3 && planInfo.enrollment_enabled == 0 && source.payment_source_type == 1 && source.source_id > 0) ? 'py-3' 
                  : '' ]">
                <span class="flex-grow-1">
                  <img style="width:30px;" class="me-2"
                    [src]="source && source.payment_source == 'Bank' ? 'assets/svg/bank.svg' : source && source.brand?'assets/svg/card-type/'+source.brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                    *ngIf="source && (source.brand);else no_card " />
                  <ng-template #no_card>
                    <img style="width:30px;" class="me-2" [src]="'assets/svg/card-type/no_card.svg'">
                  </ng-template>
                  XXXX XXXX {{source.payment_source_type != 1 ? 'XXXX ' : ''}}{{source.last4}}
                  <span *ngIf="source.source_id == -1" class="pull-right text-danger me-2">Verification
                    Pending</span>
                  <span *ngIf="source && source.bank_status && source.bank_status == 'reauthenticate' "
                    class="pull-right text-danger me-2"><a (click)="reAuthenticatePlaid()">Reauthentication
                      Required</a></span>
                  &nbsp;&nbsp;
                </span>
                <div class="custom-radio-box position-relative custom-radio-checkobx">
                  <input type="radio" [value]="source" class="ms-3" name="selected_card" [(ngModel)]="selected_card"
                    [checked]="recurring_source_id == source.source_id"
                    [disabled]="source && source.bank_status && source.bank_status == 'reauthenticate'"
                    (change)="checkValue($event,1)" />
                  <label class="radio-label"></label>
                </div>
              </div>
              <div class="offer-strip"
                *ngIf="(opened_step == 1 || opened_step == 2) && planInfo.enrollment_waiver == 1 && getNumber(planInfo.selected_payment_matrix.primary_type) == 3 && planInfo.enrollment_enabled == 0 && source.payment_source_type == 1 && source.source_id > 0 && (planInfo && planInfo.plans_array && planInfo.plans_array[0].enrollment_fee > 0)">
                Offer available: Get {{mainService.currency_data.display_logo}} {{planInfo && planInfo.plans_array &&
                planInfo.plans_array[0].enrollment_fee}} off on your contract enrollment fee!
              </div>

            </label>
          </div>

        </div>
        <!-- rescurring payment method  -->
        <div class="" *ngIf="opened_step == 2 && validValue;" class="add_card_button_1 opened_step_2"
          style="max-height: 200px;overflow-y: auto;">
          <!-- && patientData && patientData?.recurring_sources && patientData?.recurring_sources.length > 0 -->
          <div class="card-block mb-2" *ngFor="let source of patientData?.recurring_sources;let i =index">
            <label class="col-12 card_show_box mb-0"
              *ngIf="source &&  (source.payment_source_type == 1 && add_bank_step == 'bank') || (source.payment_source_type !== 1 && add_bank_step == 'card')">
              <div class="d-flex align-items-center h-100">
                <span class="flex-grow-1" [id]="i + '_recurring_card'">
                  <img style="width:30px;" class="me-2"
                    [src]="source && source.payment_source == 'Bank' ? 'assets/svg/bank.svg' : source && source.brand?'assets/svg/card-type/'+source.brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                    *ngIf="source && (source.brand);else no_card " />
                  <ng-template #no_card>
                    <img style="width:30px;" class="me-2" [src]="'assets/svg/card-type/no_card.svg'">
                  </ng-template>
                  XXXX XXXX {{source.payment_source_type != 1 ? 'XXXX ' : ''}}{{source.last4}}
                  <span *ngIf="source.source_id == -1" class="pull-right text-danger me-2">Verification
                    Pending</span>
                  <span *ngIf="source && source.bank_status && source.bank_status == 'reauthenticate' "
                    class="pull-right text-danger me-2"><a (click)="reAuthenticatePlaid()">Reauthentication
                      Required</a></span>
                  &nbsp;&nbsp;
                </span>
                <div class="custom-radio-box position-relative custom-radio-checkobx">
                  <input type="radio" [value]="source" class="ms-3" name="selected_card" [(ngModel)]="selected_card"
                    [checked]="recurring_source_id == source.source_id"
                    [disabled]="source && source.bank_status && source.bank_status == 'reauthenticate'"
                    (change)="checkValue($event,2)" />
                  <label class="radio-label"></label>
                </div>
              </div>
              <div class="offer-strip"
                *ngIf="(opened_step == 1 || opened_step == 2) && planInfo && planInfo.enrollment_waiver == 1 && source && source.payment_source_type == 1 && (planInfo && planInfo.plans_array && planInfo.plans_array[0].enrollment_fee)"
                style="position: absolute;top: 38px;left: 16px;width: 100%;max-width:439px">
                Offer available: Get {{mainService.currency_data.display_logo}} {{planInfo && planInfo.plans_array &&
                planInfo.plans_array[0].enrollment_fee}} off on your contract enrollment fee!
              </div>
            </label>
          </div>
        </div>

        <!-- backup cards    -->
        <div
          *ngIf="(opened_step == 3 && validValue) && patientData && patientData.backup_sources && patientData.backup_sources.length > 0"
          class="add_card_button_1 opened_step_3 " style="max-height: 200px;overflow-y: auto;">
          <ng-container *ngFor="let source of patientData.backup_sources">
            <div class="card-block mb-2"
              *ngIf="((source.payment_source_type == 1 && add_bank_step == 'bank') || (source.payment_source_type !== 1 && add_bank_step == 'card'))">
              <label class="col-12 card_show_box mb-0">
                <div class="d-flex align-items-center h-100">
                  <span class="flex-grow-1">
                    <img style="width:24px;" class="me-2"
                      [src]="source && source.payment_source == 'Bank' ? 'assets/svg/bank.svg' : source && source.brand?'assets/svg/card-type/'+source.brand.toLowerCase()+'.svg':'assets/svg/card-type/no_card.svg'"
                      *ngIf="source && (source.brand);else no_card " />
                    <ng-template #no_card>
                      <img style="width:24px;" class="me-2" [src]="'assets/svg/card-type/no_card.svg'">
                    </ng-template>
                    XXXX XXXX {{source.payment_source_type != 1 ? 'XXXX ' : ''}}{{source.last4}}
                    <span *ngIf="source.source_id == -1" class="pull-right text-danger me-2">Verification
                      Pending</span>
                    <span *ngIf="source && source.bank_status && source.bank_status == 'reauthenticate' "
                      class="pull-right text-danger me-2"><a (click)="reAuthenticatePlaid()">Reauthentication
                        Required</a></span>
                    &nbsp;&nbsp;
                  </span>
                  <div class="custom-radio-box position-relative custom-radio-checkobx">
                    <input type="radio" [value]="source" class="ms-3" name="selected_card" [(ngModel)]="selected_card"
                      [checked]="backup_source_id == source.source_id"
                      [disabled]="source && source.bank_status && source.bank_status == 'reauthenticate'"
                      (change)="checkValue($event,3)" />
                    <label class="radio-label"></label>
                  </div>
                </div>
              </label>
            </div>
          </ng-container>
        </div>
        <!-- [ngClass]="[stripeFieldsshow == false ? '' : 'd-none']" -->
        <!-- <div class="add-new--cardwrap"
          [ngClass]="(patientData.backup_sources && patientData.backup_sources.length>0) && add_bank_step == 'card' ? '' : 'd-none'">
          <span (click)="openAddCardBankPopup(addBankModal, 3)" [ngClass]="[stripeFieldsshow == false ? '' : 'd-none']">+ Add new
            card</span>
        </div> -->
        <!-- Add Cards Filed End -->
        <!-- <div class="col-12 border br-10 px-3 py-2 fw-600 fs-16 bg-light"
          *ngIf="add_bank_step == 'bank' && !bank_addded">
          <p class="color-grey-1">Please add your bank for the recurring payments</p>
          <p class="color-grey-1 mb-0">No payment method added</p>
        </div> -->
        <!-- <div class="row position-relative">
          <div class="col-12 my-col"
            [ngClass]="patientData.backup_sources && patientData.backup_sources.length==0 && add_bank_step == 'card' || (stripeFieldsshow && add_bank_step == 'card')?'value':'value-one'">
            <span class="add-new--stripeLabel">
            </span>
            <app-generate-stripe-token [address]="{}" [buttonClickedSubject]="buttonClickedSubject"
              (onFocussed)="CardFocussed()" [elementId]="'add_new_card'"
              (cardResponse)="CatchStripeTokenForNewCard($event, addNewPaymentMethodModal)" class="col-12 my-col"
              [show_save_card]="false" [payment_failed_first]="dp_last4" [show_address]="false" [not_Valid]="valueNotValid">
            </app-generate-stripe-token>
          </div>
        </div> -->

        <!-- <div class="d-inline-block" *ngIf="selected_card && selected_card.source_id && !showElement && ((!bank_addded && add_bank_step == 'bank') || add_bank_step != 'bank')" (click)="callIntentApi(); selected_card = ''">
          <span style="font-size: 16px;font-weight: bold;color: #1e84a8;text-decoration: underline;cursor: pointer;">
            + Add New
          </span>
        </div> -->

        <div class="w-100">
          <button button-primary-auth class="px-4 py-3 mt-0 mb-3 adding-bnk"
            *ngIf="selected_card && selected_card.last4 && (add_bank_step !== 'bank')"
            (click)="openAddCardBankPopup(addBankModal, 3)" id="add_card_now">
            <span class="px-3">
              <!-- {{showElement ? 'Add' : (selected_card && selected_card.last4 ? 'Add Now' : '+ Add New')}} -->
              Add Now
            </span>
          </button>
        </div>

        <div class="pointer">
          <input type="radio" name="existing" id="add_new_card" [checked]="showElement || add_bank_step == 'bank'">
          <label for="add_new_card" (click)="existing(buttonSelectedType.bank)"
            [ngClass]="{'d-none': add_bank_step == 'bank' && bank_addded}">
            <span style="font-weight: 600;font-size: 17px;" class="ps-2"
              *ngIf="(add_bank_step == 'bank' && !bank_addded)">Add Bank</span>
            <span style="font-weight: 600;font-size: 17px;" class="ps-2" *ngIf="add_bank_step !== 'bank'">Add new
              card</span>
          </label>
        </div>
        <div *ngIf="showElement">
          <app-generate-stripe-token [address]="{}" [buttonClickedSubject]="buttonClickedSubject"
            [selected_card]="selected_card" (onFocussed)="CardFocussed()"
            (clickParentFunction)="openAddCardBankPopup(addBankModal, 3)" [elementId]="'add_new_card'"
            (cardResponse)="CatchStripeTokenForNewCard($event, addNewPaymentMethodModal)" class="col-12 my-col"
            [show_save_card]="false" [payment_failed_first]="dp_last4" [show_address]="false"
            [not_Valid]="valueNotValid" [backUp_Card]="backUpCard" [web_connect]="false"
            [recurring_card]="recurringCard" [today_payment_card]="todayPaymentCard"
            (triggerParentFunction)="confirmPayment()" [bankType]="add_bank_step == 'bank' ? 1 : 0"
            (showElementTrigger)="showElementTrigger($event)">
          </app-generate-stripe-token>
          <!-- <div id="payment-element"></div>
          <div (click)="confirmPayment()">
            <button button-primary-auth class="px-5 w-100">Add</button>
          </div> -->
        </div>
        <div class="w-100">
          <button button-primary-auth class="px-4 py-3 mt-0 adding-bnk"
            *ngIf="selected_card && selected_card.last4 && !showElement && (add_bank_step == 'bank' && patientData && planInfo.selected_payment_matrix && ((getNumber(planInfo.selected_payment_matrix.recurring_type) == 1 || getNumber(planInfo.selected_payment_matrix.recurring_type) == 3) || (getNumber(planInfo.selected_payment_matrix.primary_type) == 1 || getNumber(planInfo.selected_payment_matrix.primary_type) == 3) || (getNumber(planInfo.selected_payment_matrix.backup_type) == 1 || getNumber(planInfo.selected_payment_matrix.backup_type) == 3)))"
            (click)="openAddCardBankPopup(addBankModal, 1)">
            <span class="px-3">
              <!-- {{showElement ? 'Add' : (selected_card && selected_card.last4 ? 'Add Now' : '+ Add new')}} -->
              Add Now
            </span>
          </button>
        </div>
        <!-- <div class="w-100 color-gray py-3"
          *ngIf="add_bank_step == 'bank' && patientData && (patientData?.plaid_access_token == null || !patientData?.plaid_access_token)">
          Credee <img src="assets/svg/plaid-logo_1.svg" class="px-1" alt="" srcset=""> to connect your account
        </div> -->
      </div>
    </div>
  </div>
</div>

<!--  modal confirm payment -->
<!-- <div bsModal #confirmPaymentModal="bs-modal" [config]="{ignoreBackdropClick:true, backdrop : 'static',
  keyboard : false}" data-keyboard="false" data-backdrop="static" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered customModal modal-md">
      <div class="modal-content successpage overflow-hidden">
        <div class="modal-body p-0">
          <div class="head_content color-blue back-light-blue px-3 py-3 text-center h5 fw-700">
            Your payment has been made successfully.
          </div>
          <div class="body_content px-4 text-center">
            <span class="fs-12 fw-700 contract_id_grey" style="color: #C3C8CD !important"
              *ngIf="split_request_data && split_request_data.length > 0">
              CONTRACT ID: {{split_request_data[0]['contract_code'] || contract_code || 'Not Available'}}
            </span>
  
            <div class="w-100">
  
              <p class="fs-16 fw-700 pt-4 pb-1 m-0 card-body">
                Payment Plan
              </p>
              <div>
                <p class="h2 text-black  fw-900 " style="font-size: 40px;margin-bottom: 34px;" *ngIf="planInfo">
                  {{planInfo && planInfo.treatment_amount ?
                  ((planInfo.treatment_amount - (planInfo.downpayment_amount || 0)) | currency : '$') :'$0.00'}}</p>
              </div>
              <div class="mt-4">
                <p class="text-black h4 fw-900 m-0 " style=" font-size: 24px; ">{{planInfo && planInfo.selected_plan &&
                  planInfo.selected_plan.month}} Months</p>
                <div class="per_month h3 py-2">
                  {{planInfo && (planInfo.recurring_amount || planInfo.selected_plan.recurring_amount) | currency : '$'}}
                  <span class="color-gray-2">per month</span>
                </div>
  
              </div>
  
            </div>
  
  
            <div class="">
              <hr class="my-5" style="  border: dashed #DFDFDF 1px;" />
            </div>
  
            <div class="w-100 text-center">
              <span class="fs-16 fw-700 py-3 card-body">First Recurring Payment Date</span>
              <p class="date_column h3 fw-900 mt-3 color-blue">{{paymentDetails.recurringDate | date:'MM/dd/yyyy'}}</p>
            </div>
  
            <div class="botton_continue" style="padding: 25px 0px 0px !important; ">
              <button button-primary-auth class="px-5" (click)="goToCustomerDetails()">Continue</button>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  </div> -->


<div bsModal #paymentFail="bs-modal" [config]="{ignoreBackdropClick:true, backdrop : 'static',
  keyboard : false}" data-keyboard="false" data-backdrop="static" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered customModal modal-md">
    <div class="modal-content overflow-hidden">
      <div class="modal-body p-0">
        <div class="head_content text-end d-flex align-items-center justify-content-end  px-3 py-2 h5 fw-700">
          <span role="button_close" class="border rounded-circle" (click)="paymentFail.hide()"><img
              src="assets/svg/close-circle.svg" alt=""></span>
        </div>
        <div class="body_content px-4 text-center">

          <div class="w-100">
            <p class="fs-16 fw-700 py-3">
              <img src="assets/svg/oppse_icon.svg" alt="">
            </p>
            <div>
              <p class="h2 color-dblue fw-900">{{"Payment Failed!"}}</p>
            </div>
            <div class="mt-5">
              <p class="color-dblue fs-16 fw-600">{{payment_error}}</p>
            </div>
          </div>

          <div class="botton_continue py-5 align-items-center d-flex flex-column">
            <button button-primary-auth class="px-5 bg-white border color-blue-imp" (click)="uploadBusinessSignature()"
              style="width: 280px !important;">Retry</button>
            <br />
            <button button-primary-auth class="px-5 -mt-4" (click)="changePaymentMethodFailed(paymentFail);"
              style="width: 280px !important;">Change Payment Method</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div bsModal #addBankModal="bs-modal" [config]="{ignoreBackdropClick:true}" class="modal" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog  modal-dialog-centered customModal modal-md">
    <div class="modal-content p-3">
      <div class="modal-header-payment pt-0">
        <h4 class="modal-title color-gray ps-3 text-capitalize">{{ payment_source_type == '1' ? 'Add bank' : 'Add
          card'}}</h4>
        <button type="button" class="close" aria-label="Close" role="button_close" (click)="addBankModal.hide();"><img
            src="assets/svg/close-circle.svg" alt=""></button>
      </div>
      <div class="modal-body pb-4">
        <!-- <div style="font-weight: 600;font-size: 17px;margin-top: 20px;"><label>Payment element</label></div> -->
        <!-- <div id="payment-element">
        </div> -->
      </div>
      <div class="modal-footer" (click)="confirmPayment()">
        <button button-primary-auth class="px-5 w-100">Add</button>
      </div>
    </div>
  </div>
</div>

<ng-template #paymentArFlow>
  <div class="new-ar">
    <div class="new-ar-header">
      <p class="fw-800 font-lg1 gray-text-color">Payable Today:
        <span class="fw-800 font-lg1 color-blue-1">{{mainService.currency_data.display_logo}}
          {{planInfo.selected_plan.to_pay_today + (creditReportOption?this.planInfo?.credit_report_amount:0) |
          DynamicDecimalPipe:mainService.currency_data.currency_code}}</span>
        <button class="info_icon_btn service-amount-btn"
          *ngIf="planInfo && planInfo.selected_plan && planInfo.selected_plan.to_pay_today > 0">
          <!-- <img src="assets\png\Icons.png" alt="" class="info_icon_btn_img"> -->
          <span class="info_icon_btn_img">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 20 20" fill="none">
              <path
                d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                stroke="#141616" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9.375 9.375H10V13.75H10.625" stroke="#141616" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M10 7.5C10.5178 7.5 10.9375 7.08027 10.9375 6.5625C10.9375 6.04473 10.5178 5.625 10 5.625C9.48223 5.625 9.0625 6.04473 9.0625 6.5625C9.0625 7.08027 9.48223 7.5 10 7.5Z"
                fill="#141616" />
            </svg>
          </span>
          <span class="tooltip_box">
            <div class="col-12 mx-auto px-0 mt-3 mb-0" *ngIf="planInfo">
              <ul style="list-style-type: none;" class="px-0 service_viewer no_scroll pt-lg-0 pt-4">
                <li class="d-flex align-items-center justify-content-between flex-wrap service_list_item"
                  *ngIf="contract_type!=3 && (split_request_data?.[0]?.downpayment_amount)">
                  <span class="color-gray fs-14">
                    Down Payment
                  </span>
                  <span class="fw-700 all-data fs-14">
                    {{mainService.currency_data.display_logo}} {{(planInfo && planInfo.downpayment_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                  </span>
                </li>
                <li class="d-flex align-items-center justify-content-between flex-wrap service_list_item"
                  *ngIf="contract_type!=3 && (!split_request_data?.[0]?.downpayment_amount)">
                  <span class="color-gray fs-14">
                    Recurring Amount
                  </span>
                  <span class="fw-700 all-data fs-14">
                    {{mainService.currency_data.display_logo}} {{(planInfo?.recurring_amount||
                    planInfo.selected_plan.recurring_amount)|DynamicDecimalPipe:mainService.currency_data.currency_code}}
                  </span>
                </li>
                <li class="d-flex align-items-center justify-content-between flex-wrap service_list_item"
                  *ngIf="contract_type!=3 && creditReportOption">
                  <span class="color-gray fs-14">
                    Credit Report Fee
                  </span>
                  <span class="fw-700 all-data fs-14">
                    {{mainService.currency_data.display_logo}} {{planInfo?.credit_report_amount | DynamicDecimalPipe:mainService.currency_data.currency_code}}
                  </span>
                </li>
                <li class="d-flex align-items-center justify-content-between service_list_item"
                  *ngIf="split_request_data && split_request_data[0].contract_type !== 3">
                  <span class="color-gray fs-14">
                    Transaction Fee
                  </span>
                  <span *ngIf="planInfo && planInfo.selected_plan"
                    class="float-end font-weight-bold  f-s-14 text-colr">{{mainService.getTransactionFee(planInfo,planInfo.selected_plan.recurring_amount,1)}}
                    / payment</span>
                </li>
              </ul>
            </div>
          </span>
        </button>
      </p>
      <div class="bg-lightgreen d-flex align-items-center justify-content-between p-2 rounded">
        <p class="font-sm color-black-new m-0">
          <span>
            <strong>{{mainService.currency_data.display_logo}}  {{
              ((planInfo?.recurring_amount || planInfo?.selected_plan?.recurring_amount) + (creditReportOption ? (+planInfo.credit_report_amount) : 0))| DynamicDecimalPipe : mainService.currency_data.currency_code}}/month</strong>
            for the next <strong>{{planInfo && planInfo.selected_plan &&
              planInfo.selected_plan.month ? ((split_request_data?.[0]?.ar_flow_immediate && split_request_data?.[0]?.downpayment_amount) ? (planInfo.selected_plan.month) : planInfo.selected_plan.month - 1) : '0'}} months</strong>
          </span>
        </p>
        <p class="fw-500 font-sm color-green m-0 d-flex align-items-center">
          <img src="assets\svg\calendar-daygreen.svg" alt="" class="me-1" />
          <span>Next Recurring Date: <input #dob="ngModel" name="date_of_birth"
              class="border-0 fw-500 font-sm color-green" [max]="planInfo.max_date" [min]="planInfo.min_date"
              [(ngModel)]="paymentDetails.recurringDate" readonly></span>
        </p>
      </div>
    </div>
    <div class="gateWay_add_card">
      <div class="primary_cardBox row align-items-center">
        <div class="col-md-8">
          <p class="fs-16 fw-600 color-black-new mb-2">Payment Method</p>
          <p class="fs-14 color-grey-6">This payment method will be used for today's payment and all future recurring charges.</p>
        </div>
        <div class="add_primary card_add col-md-4 text-end">
          <button type="button" class="add_only" (click)="openModal_1(1,addNewPaymentMethodModal)"
            *ngIf="!dp_source_id">
            <span id="primary_id" tabindex="-1">Add</span>
          </button>
          <!-- <button type="button"> -->
            <div class="d-flex align-items-center justify-content-between cardDetailDiv" *ngIf="dp_source_id">
              <div class="d-flex align-items-center">
                <img style="width:24px;" class="mr-2"
                  [src]="(getMyCard(dp_source_id,'primary_sources') && getMyCard(dp_source_id,'primary_sources').payment_source == 'Bank' ? 'assets/svg/bank.svg' : getMyCard(dp_source_id,'primary_sources') && getMyCard(dp_source_id,'primary_sources').brand?'assets/svg/card-type/'+getMyCard(dp_source_id,'primary_sources').brand+'.svg':'assets/svg/card-type/no_card.svg') || 'assets/svg/card-type/no_card.svg'"
                  *ngIf="getMyCard(dp_source_id,'primary_sources') && getMyCard(dp_source_id,'primary_sources')?.payment_source" />
                <span class="ms-2" translate="no">{{getMyCard(dp_source_id,'primary_sources') &&
                  getMyCard(dp_source_id,'primary_sources').last4}}</span>
              </div>
              <img src="assets\svg\pencil-01.svg" alt="" (click)="openModal_1(1,addNewPaymentMethodModal)">
            </div>
          <!-- </button> -->
        </div>
      </div>
       <div class="recurring_cardBox row align-items-center">
        <div class="col-md-8">
          <p class="fs-16 fw-600 color-black-new mb-2">Recurring Payment Method</p>
          <p class="fs-14 color-grey-6">All future recurring payments will be charged to this payment method.</p>
        </div>
        <div class="add_recurring card_add col-md-4 text-end">
          <button type="button" class="add_only" (click)="openModal_1(2,addNewPaymentMethodModal)"
            *ngIf="!recurring_source_id">
            <span id="recurring_id" tabindex="-1">Add</span>
          </button>
            <div class="d-flex align-items-center justify-content-between cardDetailDiv" *ngIf="recurring_source_id">
              <div class="d-flex align-items-center">
                <img style="width:24px;" class="mr-2"
                  [src]="getMyCard(recurring_source_id,'recurring_sources') && getMyCard(recurring_source_id,'recurring_sources').payment_source == 'Bank' ? 'assets/svg/bank.svg' : getMyCard(recurring_source_id,'recurring_sources').brand?'assets/svg/card-type/'+getMyCard(recurring_source_id,'recurring_sources').brand+'.svg':'assets/svg/card-type/no_card.svg'"
                  *ngIf="getMyCard(recurring_source_id,'recurring_sources') && getMyCard(recurring_source_id,'recurring_sources')?.payment_source" />
                <span class="ms-2">{{getMyCard(recurring_source_id,'recurring_sources') &&
                  getMyCard(recurring_source_id,'recurring_sources').last4}}</span>
              </div>
              <img src="assets\svg\pencil-01.svg" class="" alt=""
                (click)="openModal_1(2,addNewPaymentMethodModal);gettingCard = false">
            </div>
        </div>
      </div>
      <div class="backup_cardBox row align-items-center">
        <div class="col-md-8">
          <p class="fs-16 fw-600 color-black-new mb-2">Backup Payment Method <span
              class="color-yellowdark">{{planInfo?.selected_payment_matrix?.backup_required ? '(Recommended)' : '(Optional)'}}</span> </p>
          <p class="fs-14 color-grey-6">A backup payment method is recommended for the benefit of both parties. Timely
            payments will be reported to
            credit bureaus, helping boost your customer's credit scores.</p>
        </div>
        <div class="add_backup card_add col-md-4 text-end">
          <button type="button" class="add_only" (click)="openModal_1(3,addNewPaymentMethodModal)"
            *ngIf="!backup_source_id">
            <span id="backup_id">Add</span>
          </button>
          <!-- <button type="button" *ngIf="backup_source_id"> -->
            <div class="d-flex align-items-center justify-content-between cardDetailDiv" *ngIf="backup_source_id">
              <div class="d-flex align-items-center">
                <img style="width:24px;" class="mr-2"
                  [src]="getMyCard(backup_source_id,'backup_sources') && getMyCard(backup_source_id,'backup_sources').payment_source == 'Bank' ? 'assets/svg/bank.svg' : getMyCard(backup_source_id,'backup_sources').brand?'assets/svg/card-type/'+getMyCard(backup_source_id,'backup_sources').brand+'.svg':'assets/svg/card-type/no_card.svg'"
                  *ngIf="getMyCard(backup_source_id,'backup_sources') && getMyCard(backup_source_id,'backup_sources')?.payment_source" />
                <span class="ms-2">{{getMyCard(backup_source_id,'backup_sources') &&
                  getMyCard(backup_source_id,'backup_sources').last4}}</span>
              </div>
              <div>
                <img src="assets\svg\pencil-01.svg" class="edit-pencil me-2" alt=""
                  (click)="openModal_1(3,addNewPaymentMethodModal);gettingCard = false">
                <img src="assets\svg\delete-icon.svg" class="delete-bin" alt="" (click)="backup_source_id = null">
              </div>
            </div>
          <!-- </button> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>